export const getNextInputValue = (input: HTMLInputElement, inputVal: string): string => {
  const currentValue = String(input.value ?? '');
  const selectionStart = input.selectionStart ?? currentValue.length;
  const selectionEnd = input.selectionEnd ?? currentValue.length;

  return currentValue.slice(0, selectionStart) + inputVal + currentValue.slice(selectionEnd);
};
